import _toConsumableArray from "/var/lib/jenkins/workspace/aws-PROD-deploy-react-form/node_modules/react-scripts/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
export function createCSSVarName(data, prefix) {
  if (!data || Object.keys(data).length === 0) {
    throw new Error('invalid data');
  }

  var path = [].concat(_toConsumableArray(prefix ? [prefix] : []), _toConsumableArray(typeof data === 'string' ? [data] : Object.keys(data).sort().reduce(function (acc, key) {
    return [].concat(_toConsumableArray(acc), [key, data[key]]);
  }, [])));
  return "--".concat(path.join('-').toLowerCase().replace(/[^a-z,0-9-]/g, '-'));
}